import { UserGroupIcon } from '@heroicons/react/24/outline';
import { InfoIcon } from 'lucide-react';

import { Loader } from '@/components/Loader';
import { Tooltip } from '@/components/Tooltip';
import { Container } from '@/components/legacy-ui';
import { MONITORING_TOOLTIP_MAP } from '@/hooks/monitoringConstants';
import { MonitoringCounts, SubscriptionConfiguration } from '@/types';
import { cn } from '@/utils/classname';

import { NotIncludedBadge } from './NotIncludedBadge';

interface SocialEngineeringCardProps {
  monitoringCounts: MonitoringCounts;
  subscriptionValue?: SubscriptionConfiguration;
  isLoading: boolean;
}

export function SocialEngineeringCard({
  monitoringCounts,
  subscriptionValue,
  isLoading,
}: SocialEngineeringCardProps) {
  const socialEngineeringCovered = Boolean(
    subscriptionValue?.attackSurface?.users
  );
  const adUserCount = monitoringCounts.internalNetwork.ADUser || 0;

  return (
    <Container className="flex h-full w-full flex-col gap-3">
      <div className="mb-1 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <h3 className="text-lg font-bold">Social Engineering</h3>
        </div>
        <div className="flex items-center gap-2">
          {!socialEngineeringCovered && <NotIncludedBadge />}
          <Loader
            className="my-[5.5px] h-[16px] w-[48px] rounded-3xl"
            isLoading={isLoading}
          >
            <div className="border-chariot-stroke text-chariot-text-primary rounded-2xl border px-3 py-1 text-xs font-medium">
              now
            </div>
          </Loader>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <UserGroupIcon className="text-chariot-stroke size-6 shrink-0" />
        <h4 className="text-sm font-bold whitespace-break-spaces">
          Total Number of Users Monitored
        </h4>
        <Loader
          className="my-[5.5px] ml-auto h-[16px] w-[48px] rounded-3xl"
          isLoading={isLoading}
        >
          <div className="bg-chariot-background-secondary ml-auto min-w-12 rounded-md px-3 py-1 text-center text-sm font-bold">
            {adUserCount.toString()}
          </div>
        </Loader>
      </div>
      <div className={cn('bg-chariot-stroke h-px w-full')} />
      <div className="flex flex-col gap-4">
        <div className="flex w-full items-center justify-between">
          <div className="flex items-center gap-2">
            <h4 className="text-sm font-bold whitespace-break-spaces capitalize">
              AD Users
            </h4>
            <Tooltip title={MONITORING_TOOLTIP_MAP['ADUser'] || ''}>
              <InfoIcon className="text-chariot-text-primary size-4" />
            </Tooltip>
          </div>
          <Loader
            className="my-[5.5px] ml-auto h-[16px] w-[48px] rounded-3xl"
            isLoading={isLoading}
          >
            <div className="bg-chariot-background-secondary min-w-12 rounded-md px-3 py-1 text-center text-sm font-bold">
              {adUserCount.toString()}
            </div>
          </Loader>
        </div>
      </div>
    </Container>
  );
}
